import { useState } from "react";
import {
  initialFormState,
  validateAllFields,
  fetchCityState,
  validationRules,
} from "../formData";

export const useFormState = () => {
  const [form, setForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [fetchingPin, setFetchingPin] = useState(false);

  const validateField = (name, value) => {
    if (validationRules[name]) {
      const isValid = validationRules[name](value);
      setErrors((err) => ({
        ...err,
        [name]: isValid === true ? undefined : isValid,
      }));
    }
  };

  const handleMobileChange = (value) => {
    const onlyNums = value.replace(/\D/g, "").slice(0, 10);
    setForm((prev) => ({ ...prev, mobile: onlyNums }));
    validateField("mobile", onlyNums);
  };

  const handlePincodeChange = async (value) => {
    setForm((prev) => ({ ...prev, pincode: value }));

    if (/^\d{6}$/.test(value)) {
      setFetchingPin(true);
      const { city, state, pincodeError } = await fetchCityState(value);
      setForm((prev) => ({
        ...prev,
        city: city || "",
        state: state || "",
      }));
      setErrors((err) => ({
        ...err,
        pincode: pincodeError ? pincodeError : undefined,
      }));
      setFetchingPin(false);
    } else {
      setForm((prev) => ({
        ...prev,
        city: "",
        state: "",
      }));

      if (value.length === 6) {
        setErrors((err) => ({
          ...err,
          pincode: "Your pin code is wrong",
        }));
      } else {
        validateField("pincode", value);
      }
    }
  };

  const handleFieldChange = async (name, value) => {
    if (name === "mobile") {
      handleMobileChange(value);
      return;
    }

    if (name === "pincode") {
      await handlePincodeChange(value);
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handleFieldBlur = async (name, value) => {
    validateField(name, value);

    if (name === "pincode" && /^\d{6}$/.test(value)) {
      setFetchingPin(true);
      const { city, state, pincodeError } = await fetchCityState(value);
      setForm((prev) => ({
        ...prev,
        city: city || "",
        state: state || "",
      }));
      setErrors((err) => ({
        ...err,
        pincode: pincodeError ? pincodeError : undefined,
      }));
      setFetchingPin(false);
    } else if (name === "pincode" && value.length === 6) {
      setErrors((err) => ({
        ...err,
        pincode: "Your pin code is wrong",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = validateAllFields(form, errors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setForm(initialFormState);
    setErrors({});
  };

  return {
    form,
    errors,
    fetchingPin,
    handleFieldChange,
    handleFieldBlur,
    validateForm,
    resetForm,
    setForm,
  };
};
